<template>
    <component v-bind:is="button"
               v-bind="Object.assign($attrs, $options.propsData, $listeners)"
               v-on="$listeners">
        <template v-for="slotName in Object.keys($scopedSlots)"
                  v-slot:[slotName]="slotProps">
            <slot :name="slotName" v-bind="slotProps"/>
        </template>
    </component>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {VueConstructor} from "vue";
import Button from "./GenericButton/Button";
import ButtonEnums from './GenericButton/ButtonEnums'

/** Liste des composants de bouton */
import ButtonIconComplexe from './GenericButton/Button/ButtonIcon/ButtonIconComplexe.vue'
import ButtonIconComplexeSave from './GenericButton/Button/ButtonIcon/ButtonIconComplexeSave.vue'
import ButtonIconSimple from './GenericButton/Button/ButtonIcon/ButtonIconSimple.vue'
import ButtonLabelComplexe from './GenericButton/Button/ButtonLabel/ButtonLabelComplexe.vue'
import ButtonLabelSimple from './GenericButton/Button/ButtonLabel/ButtonLabelSimple.vue'

const ButtonsType = ButtonEnums.ButtonTypeEnum;
const ButtonsAction = ButtonEnums.ButtonActionEnum;

export {ButtonsType, ButtonsAction}
export * as ButtonIconParameters from "./GenericButton/Button/ButtonIcon/ButtonIconSimpleParameters";
export * as ButtonLabelParameters from "./GenericButton/Button/ButtonLabel/ButtonLabelSimpleParameters";

@Component({
    components: {
        ButtonIconComplexe, ButtonIconComplexeSave, ButtonIconSimple,
        ButtonLabelComplexe, ButtonLabelSimple
    },
    i18n: GenericButton.MessageLocales()
})
export default class GenericButton extends Button {
    @Prop({default: () => ""})
    public Type!: string;

    @Prop({default: () => ""})
    public ButtonAction!: string;

    private button: VueConstructor<any>;

    protected created() {
        console.warn("⛔⛔⛔LE COMPOSANT '%s' EST OBSOLÊTE ET NE DOIT PLUS ETRE UTILISÉ !!!! ⛔⛔⛔", this.$options.name)
        this.button = ButtonEnums.Buttons['Button' + this.Type + this.ButtonAction];

        if (this.button == undefined)
            console.log('Le bouton Button' + this.Type + this.ButtonAction + ' n\'existe pas.');
    }
}
</script>

<style scoped>
</style>